const URL = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : 'http://localhost:12345';

export default URL;
